import { Divider } from "@landtechnologies/components";
import { routedClient, Stores, useGlobalState, useTranslation } from "react-migration/lib";
import { useAccountQuery } from "../hooks/useAccountQuery";
import Feature from "src/js/stores/user/Feature";
import { mastermapTilesToViews } from "src/js/util/units_and_constants";
import { formatDate } from "react-migration/domains/comparables";
import { UsageRow } from "./UsageRow";
import { Account } from "react-migration/domains/constraints/typings/applicationTypes/Account";
import { CurrentPlan } from "./CurrentPlan";
import { useEffect } from "react";
import ACOUNT_DOCUMENT from "../apollo/queries/account.gql";
export const Usage = () => {
  const { t } = useTranslation();
  const { data } = useAccountQuery();
  const account = data?.accountWithViews as Account;
  const [, { hasFeature }] = useGlobalState(Stores.user);

  useEffect(() => {
    routedClient.refetchQueries({ include: [ACOUNT_DOCUMENT] });
  }, []);

  const hasMasterMapFeature = hasFeature(Feature.masterMap);
  const hasUnlimitedMasterMapClicksFeature = hasFeature(Feature.unlimitedMasterMapClicks);
  const hasOwnershipLayerFeature = hasFeature(Feature.ownershipLayer);
  const hasUnlimitedOwnershipClicksFeature = hasFeature(Feature.unlimitedOwnershipClicks);
  const hasPlanningLayerFeature = hasFeature(Feature.planningLayer);
  const hasUnlimitedPlanningClicksFeature = hasFeature(Feature.unlimitedPlanningClicks);

  return (
    <div className="atlas-pt-6">
      <Divider className="atlas-mb-6" />
      <p className="atlas-font-semibold atlas-text-xl atlas-mb-5 atlas-text-neutral-800">
        {t("dashboard.credit_summary.usage")}
      </p>
      <CurrentPlan />
      {hasMasterMapFeature && (
        <UsageRow
          title={t("dashboard.credit_summary.os_mastermap_views")}
          used={mastermapTilesToViews(account?.mastermap_tiles?.used)}
          cap={mastermapTilesToViews(account?.mastermap_tiles?.cap)}
          resetDate={
            account?.mastermap_tiles.next_reset_date
              ? formatDate(account?.mastermap_tiles.next_reset_date)
              : ""
          }
          isUnlimited={hasUnlimitedMasterMapClicksFeature}
        >
          {hasUnlimitedMasterMapClicksFeature ? (
            t("dashboard.credit_summary.currently_running_test_to_provide_unlimited_map_views")
          ) : (
            <>
              {t("dashboard.credit_summary.used_when_viewing_os_mastermap")}
              <a
                href="https://support.landinsight.io/account-management/credits-and-views/how-many-os-map-views-do-i-have-left"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("dashboard.credit_summary.here")}
              </a>
              .
            </>
          )}
        </UsageRow>
      )}

      {hasOwnershipLayerFeature && (
        <UsageRow
          title={t("dashboard.credit_summary.ownership_clicks")}
          progressBarColor="atlas-bg-blue-600"
          used={account?.ownership_views.used}
          cap={account?.ownership_views.cap}
          unlimitedMessage={t("dashboard.credit_summary.unlimited")}
          isUnlimited={hasUnlimitedOwnershipClicksFeature}
          resetDate={
            account?.ownership_views.next_reset_date
              ? formatDate(account?.ownership_views.next_reset_date)
              : ""
          }
        >
          {t("dashboard.credit_summary.used_if_you_click_on")}
        </UsageRow>
      )}
      {hasPlanningLayerFeature && (
        <UsageRow
          title={t("dashboard.credit_summary.planning_views")}
          used={account?.planning_views.used}
          cap={account?.planning_views.cap}
          unlimitedMessage={t("dashboard.credit_summary.unlimited")}
          isUnlimited={hasUnlimitedPlanningClicksFeature}
          resetDate={
            account?.planning_views.next_reset_date
              ? formatDate(account?.planning_views.next_reset_date)
              : ""
          }
        >
          {t("dashboard.credit_summary.used_when_you_view")}
        </UsageRow>
      )}
    </div>
  );
};
